import { render, staticRenderFns } from "./ProductListHideConfirmModal.vue?vue&type=template&id=6b2f1bc6"
import script from "./ProductListHideConfirmModal.vue?vue&type=script&lang=js"
export * from "./ProductListHideConfirmModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports